import React from 'react'

class LogoQa extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#F8B3B2" d="M374.418 210.716c-14.002-8.092-79.034-40.07-106.108-41.826-14.393-.928-29.497 2.987-43.476 8.82-14.74-15.477-46.438-48.572-52.542-53.536-16.6-13.5-82.43-51.41-91.168-37.287 0 0 25.097 78.224 94.127 120.522-1.74 1.35-3.19 2.52-4.27 3.41-18.52-11.19-58.41-35.14-65.792-38.35-20.085-8.72-96.6-27.72-102.9-11.18 0 0 54.907 92.372 159.788 99.48.934.06 1.825.11 2.728.16-7.472 71.57-23.21 179.767-23.21 179.767s74.5 47.85 143.35 22.94c63.51-22.98 64.67-98.14 64.67-98.14-20.306-12.552-20.454-62.17-13.39-64.34 6.477-2 22.738-17.054 9.525-15.27-13.21 1.788-27.08-6.526-14.067-7.052l1.86 2.554 2.23-2.944 2.314 3.174 2.6-4.132c.01-.005.02-.005.03-.01l2.923 4.014s3.293-2.706 2.98-5.767c10.466-3.685 20.98-10.556 24.663-20.254 5.55-14.602 22.1-33.815 3.145-44.765"/>
                    <path fill="#FEFEFE" d="M273.445 248.052L266.267 215l-5.83 1.26 7.178 33.052"/>
                    <path fill="#FEFEFE" d="M284.135 231.485l-33.127 7.16-1.263-5.818 33.128-7.16"/>
                </g>
            </svg>

        );
    }
}

export default LogoQa



// WEBPACK FOOTER //
// ../components/SVG/LogoQa.jsx